import EventHome from '@/screens/EventHome';

export default function PrivateTabsEventIndexRoute() {
  return <EventHome />;
}
